import { NODES_EXTRA_DATA } from '../const';
import { NodeEnum } from '../types';

export const useNodeDefault = (nodeType: NodeEnum) => {
  return NODES_EXTRA_DATA[nodeType];
};
